// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"cf729da0","171":"14e45fb7","374":"2efc539b","432":"eaa2ef57","446":"e1921466","453":"f88c348f","507":"2e19f30d","903":"0e2e4565","923":"caa4c557"}[chunkId] + ".chunk.js";
};